import { useEffect, useRef, useState } from "react";

/**
 * Debounced free-text search state for the admin dataset tables.
 *
 * `searchInput` binds to the field; `search` is the trimmed value to send to
 * the API (or to filter a client-side list with). `onSettle` fires whenever
 * the debounced value is applied so callers can reset pagination to page 1.
 */
export const useDebouncedSearch = (onSettle?: () => void, delayMs = 300) => {
  const [searchInput, setSearchInput] = useState("");
  const [search, setSearch] = useState("");

  // Kept in a ref so an inline arrow from the caller does not restart the timer
  // on every render.
  const onSettleRef = useRef(onSettle);
  useEffect(() => {
    onSettleRef.current = onSettle;
  });

  useEffect(() => {
    const handle = window.setTimeout(() => {
      setSearch(searchInput.trim());
      onSettleRef.current?.();
    }, delayMs);
    return () => window.clearTimeout(handle);
  }, [searchInput, delayMs]);

  return {
    searchInput,
    setSearchInput,
    search,
    clearSearch: () => setSearchInput(""),
  };
};
